import { workflowRunsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type { CostRates } from '../types/cost-rates.types';

/**
 * Per-product cost of each run option for a subsidiary's connector; `contentFields` matches the
 * content rate to runs that asked for as many fields.
 */
export async function fetchCostRates(
  subsidiaryId: string,
  connectorCode: string,
  contentFields: number,
): Promise<CostRates> {
  const body = await workflowRunsClient
    .get(endpoints.costEstimates.rates(), {
      searchParams: {
        subsidiaryId,
        connectorCode,
        ...(contentFields > 0 ? { contentFields } : {}),
      },
    })
    .json<Partial<CostRates> | null>();
  // A workflow-service without this route answers `cost-estimates/{workflowId}` for "rates" with
  // another shape: treat it as no rates (the stepper says so) rather than read a missing list.
  if (!body || !Array.isArray(body.rates)) {
    throw new Error('Cost rates are not available from this workflow-service');
  }
  return body as CostRates;
}
